<div class="container-fluid">

    <div class="header-image">
        <img class="header-img" height="216" width="270" alt="failure image" src="../../../../../../../assets/gif/finzy-flex/portfolio-creation-failure.svg" />
    </div>

    <div class="header">
        <p>Something Went Wrong</p>
    </div>

    <div class="text">
        <p>We encountered an error while trying to complete your investments.</p>
    </div>

    <div>
        <button type="button" class="track-btn" (click)="onClickTryAgain()">please try again</button>
    </div>
</div>
